import {
  Box,
  Card,
  CardContent,
  Paper,
  FormControl,
  Stack,
  Typography,
  Divider,
  Button,
  InputAdornment,
  TextField,
  CircularProgress,
  IconButton,
} from "@mui/material";

import { Grid, Select, MenuItem } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import { theme } from "@/components/Elements/theme";
import storage from "@/utils/storage";
import axios from "axios";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { QRCodeSVG } from "qrcode.react";
import { io } from "socket.io-client";

// Cryptocurrency icon mapping
const getCryptoIcon = (symbol: string): string => {
  // Convert symbol to lowercase and remove network suffix
  const baseSymbol = symbol.split('-')[0].toLowerCase();
  return `https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons@master/128/color/${baseSymbol}.png`;
};

interface FormValues {
  cryptoType: string;
}
interface CoinRateItem {
  Id: number;
  Symbol: string;
  Name: string;
}
interface ErrorState {
  cryptoType?: string;
  amount?: any;
  walletAddress?: string;
}

interface DepositCrypto {
  paymentDetails: {
    Id: number;
    ExternalId: string;
    Label: string;
    Address: string;
    Created: string;
    Status: string;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    Error?: string | null;
    Aml: {
      Score?: number | null;
      Level?: string | null;
      LastChecked?: string | null;
      Sources?: any;
      Counterparties?: any;
    };
  };
}


const useStyles = makeStyles({
  kycContent: {
    maxWidth: "700px",
    color: "white",
    textAlign: "start",
    "& h1": {
      color: "#3C37FF",
      fontSize: "23px",
    },
    "& strong": {
      color: "white",
    },
    "& p, & ul, & ol": {
      color: "white",
    },
    "& ul, & ol": {
      margin: "10px 0",
      paddingLeft: "20px",
    },
    "& ul ul, & ul ol, & ol ul, & ol ol": {
      paddingLeft: "20px",
    },
  },
  sizee: {
    fontSize: "0.8rem", // Slightly larger text
    lineHeight: "1.6", // Improved line spacing for readability
  },
});

// Payment status mapping function
const getPaymentStatusInfo = (statusCode: number) => {
  const statusMap = {
    0: { message: "No Payment", type: "info" },
    1: { message: "Payment Queued", type: "info" },
    2: { message: "Payment Completed", type: "success" },
    3: { message: "Payment Failed", type: "error" },
    4: { message: "Processing Payment", type: "info" },
    5: { message: "Waiting for Confirmation", type: "info" },
    6: { message: "Payment Cancelled", type: "error" },
    7: { message: "Payment Under Review", type: "warning" },
    8: { message: "Waiting for Gas", type: "info" },
    9: { message: "Waiting for Energy", type: "info" }
  };
  return statusMap[statusCode] || { message: "Unknown Status", type: "info" };
};

export const CryptoPaymentModule = () => {
  const classes = useStyles();

  const [error, setError] = useState<ErrorState>({});
  const [isAddressAvailable, setIsAddressAvailable] = useState(false);
  const [lodingQrLoding, setLodingQrLoding] = useState(false);
  const [dyanamicCryptoAddress, setDyanamicCryptoAddress] = useState<string>("");
console.log(dyanamicCryptoAddress, "dyanamicCryptoAddress");
  const [loadingCurrency, setLoadingCurrency] = useState(false);
  const [formValues, setFormValues] = useState<FormValues>({ cryptoType: "" });
  console.log(formValues, "formValues");
  const [coinList, setcoinList] = useState<CoinRateItem[]>([]);
  const depositAddressRef = useRef("");
  const [address, setAddress] = useState("");
  const [copyStatus, setCopyStatus] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState<{
    status: string;
    payment: {
      status: number;
      amount: number;
      currency: string;
      transactionId: string;
    } | null;
  }>({ status: "", payment: null });
console.log(paymentStatus, "paymentStatus");
  // Socket connection setup
  useEffect(() => {
    const userId = JSON.parse(localStorage.getItem("crypto_react_userid") || "{}");
    console.log("Initializing socket with userId:", userId);

    console.log("Socket URL:", process.env.REACT_APP_SOCKET_URL || "http://localhost:4001");
    const socket = io(process.env.REACT_APP_SOCKET_URL || "http://localhost:4001", {
      path: '/api/v1/user/socket.io',
      transports: ['polling', 'websocket'],
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 10000,
      forceNew: true,
      autoConnect: true,
      withCredentials: false,
      query: { userId: userId } // Add userId to query params
    });

    // Setup periodic ping to keep connection alive
    const pingInterval = setInterval(() => {
      if (socket.connected) {
        socket.emit('ping');
        console.log('Ping sent at:', new Date().toISOString());
      }
    }, 25000); // Send ping every 25 seconds

    // Debug socket state
    console.log("Socket state:", socket);

    // Debug: Log connection URL
    console.log("Attempting to connect to:", process.env.REACT_APP_SOCKET_URL || "http://localhost:4001");

    let reconnectAttempts = 0;
    const maxReconnectAttempts = 5;

    // Connect and join user's room
    socket.on("connect", () => {
      console.log("Socket connected successfully");
      console.log("Socket ID:", socket.id);
      console.log("Transport:", socket.io.engine.transport.name);
      
      reconnectAttempts = 0; // Reset reconnect attempts on successful connection
      
      const roomName = `user_${userId}`;
      console.log("Joining room:", roomName);
      socket.emit("join_room", roomName);
    });
    socket.on("message", (data) => {
      console.log("Message received:", data);
    });
    // Connection error handling
    socket.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
      console.log("Current transport:", socket.io.engine?.transport?.name);
      
      reconnectAttempts++;
      
      if (reconnectAttempts >= maxReconnectAttempts) {
        console.log("Maximum reconnection attempts reached");
        toast.error("Unable to establish connection. Please refresh the page.");
        return;
      }

      // Try to reconnect with polling if websocket fails
      if (socket.io.engine?.transport?.name === "websocket") {
        console.log("Falling back to polling transport");
        socket.io.opts.transports = ["polling", "websocket"];
      }

      toast.warning("Connection lost. Attempting to reconnect...");
    });

    // Listen for all socket events for debugging
    socket.onAny((eventName, ...args) => {
      console.log(`Socket Event Received - ${eventName}:`, args);
    });

    // Payment status mapping
    const getPaymentStatusInfo = (statusCode: number) => {
      const statusMap = {
        0: { message: "No Payment", type: "info" },
        1: { message: "Payment Queued", type: "info" },
        2: { message: "Payment Completed", type: "success" },
        3: { message: "Payment Failed", type: "error" },
        4: { message: "Processing Payment", type: "info" },
        5: { message: "Waiting for Confirmation", type: "info" },
        6: { message: "Payment Cancelled", type: "error" },
        7: { message: "Payment Under Review", type: "warning" },
        8: { message: "Waiting for Gas", type: "info" },
        9: { message: "Waiting for Energy", type: "info" }
      };
      return statusMap[statusCode] || { message: "Unknown Status", type: "info" };
    };

    // Listen for payment updates - both on the room-specific channel and general channel
    const paymentUpdateHandler = (data: any) => {
      console.log("Raw payment update received:", data);
      
      try {
        // Ensure data is properly structured
        const paymentData = {
          status: data.status || "unknown",
          payment: data.payment ? {
            status: Number(data.payment.status) || 0,
            amount: Number(data.payment.amount) || 0,
            currency: data.payment.currency || "",
            transactionId: data.payment.transactionId || ""
          } : null
        };

        console.log("Processed payment data:", paymentData);
        console.log("Payment update event received at:", new Date().toISOString());

        // Update payment status in state
        setPaymentStatus(paymentData);
        
        // Handle payment status updates with toast notifications
        if (paymentData.payment) {
          const statusInfo = getPaymentStatusInfo(paymentData.payment.status);
          const message = `${statusInfo.message} ${paymentData.payment.amount > 0 ? `- ${paymentData.payment.amount} ${paymentData.payment.currency}` : ''}`;
          
          switch (statusInfo.type) {
            case 'success':
              toast.success(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
              });
              break;
            case 'error':
              toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
              });
              break;
            case 'warning':
              toast.warning(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
              });
              break;
            default:
              toast.info(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
              });
          }
          
          console.log("Payment status update:", {
            Status: statusInfo.message,
            Amount: paymentData.payment.amount,
            Currency: paymentData.payment.currency,
            TransactionId: paymentData.payment.transactionId
          });
        }
      } catch (error) {
        console.error("Error processing payment update:", error);
        console.log("Problematic data:", data);
      }
    };

    // Listen on both channels
    socket.on("payment_update", paymentUpdateHandler);
    socket.on(`payment_update_${userId}`, paymentUpdateHandler);
  
    // Removed duplicate event listener since we're already handling payment_update event

    // Handle socket errors
    socket.on("error", (error) => {
      console.error("Socket general error:", error);
      toast.error("Connection error. Please refresh the page.");
    });

    // Handle disconnection
    socket.on("disconnect", (reason) => {
      console.log("Socket disconnected. Reason:", reason);
    });

    // Handle reconnection attempts
    socket.on("reconnect_attempt", (attemptNumber) => {
      console.log("Socket reconnection attempt:", attemptNumber);
    });

    socket.on("reconnect", (attemptNumber) => {
      console.log("Socket reconnected after attempts:", attemptNumber);
      // Rejoin room after reconnection
      const roomName = `user_${userId}`;
      socket.emit("join_room", roomName);
    });

    // Debug: Listen for all events
    socket.onAny((eventName, ...args) => {
      console.log("Received socket event:", eventName, args);
    });

    // Debug: Log room joining confirmation if your server emits it
    socket.on("room_joined", (data) => {
      console.log("Room joined confirmation:", data);
    });

    // Handle pong responses
    socket.on('pong', () => {
      console.log('Pong received at:', new Date().toISOString());
    });

    // Handle explicit disconnection events
    socket.io.on("reconnect_attempt", () => {
      console.log('Socket attempting to reconnect at:', new Date().toISOString());
    });

    socket.io.on("reconnect_failed", () => {
      console.log('Socket reconnection failed at:', new Date().toISOString());
      // Try to re-establish connection
      socket.connect();
    });

    // Cleanup on component unmount
    return () => {
      console.log("Component unmounting, cleaning up socket connection");
      clearInterval(pingInterval); // Clear the ping interval
      socket.disconnect();
    };
  }, []); // Empty dependency array as we want this to run only once

  const Item = styled(Paper)(({ theme }) => ({
    background: "transparent",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  }));

  var cardStyle = {
    display: "flex",
    transitionDuration: "0.3s",
    background: "#050518",
    boxShadow: "0px 4px 50px 30px rgba(181, 181, 181, 0.05)",
    borderRadius: "20px",
  };
  useEffect(() => {
    if (dyanamicCryptoAddress) {
      setIsAddressAvailable(true);
    }
  }, [dyanamicCryptoAddress]);
  useEffect(() => {
    const fetchCurrencyData = async () => {
      setLoadingCurrency(true);
      let token = storage.getToken();
      try {
        const currencyResponse = await axios.get(
          `${process.env.API_URL_PREFIX}/api/v1/user/bithide/getCurrencyList`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        // Ensure we have an array, if not, convert it to an array
        const currencyData = Array.isArray(currencyResponse.data.Cryptocurrencies) ? currencyResponse.data.Cryptocurrencies : [];
        console.log(currencyData, "currencyData");
        setcoinList(currencyData);
      } catch (error) {
        console.error("Error fetching coin rate:", error);
      } finally {
        setLoadingCurrency(false);
      }
    };

    fetchCurrencyData();
  }, []);

  useEffect(() => {
     if (!formValues.cryptoType) {
   
    return;
  }

    const genrateAddress = async () => {
      setLodingQrLoding(true);
      let token = storage.getToken();

      try {
        const userId = JSON.parse(localStorage.getItem("crypto_react_userid") || "{}");
        console.log(userId, "userId");
        const payload = {
          ExternalId: userId,
          Currency: formValues.cryptoType,
          New: true,
          ExpectedAmount: 0.0001, // You might want to make this dynamic
          CallBackLink: `${process.env.CALLBACK_URL}/api/v1/user/bithide-confirmation`,
          AdditionalInfo: "Deposit Address Generation",
          Comment: "Crypto Deposit",
          Label: userId,
         
        };

        const genrateAddressResponse = await axios.post(
          `${process.env.API_URL_PREFIX}/api/v1/user/bithide/dynamicAddress`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            withCredentials: false
          }
        );

        const response = genrateAddressResponse?.data;
        console.log(response, "response");
        setDyanamicCryptoAddress(response.paymentDetails.Address);
        
      } catch (error) {
        console.error("Error fetching coin rate:", error);
      } finally {
        setLodingQrLoding(false); 
      }
    };

    genrateAddress();
  }, [formValues.cryptoType]);

 


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "cryptoType") {
      const selectedCoin = coinList.find((item) => item.Symbol === value);

      setFormValues({
        ...formValues,
        cryptoType: value,
      });
    } else {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };

  const checkValidation = (type) => {
    let isFormValid = true;
    let newError = { ...error };

    if (type === "cryptoType" || type === "all") {
      if (!formValues?.cryptoType || formValues?.cryptoType === "select") {
        newError.cryptoType = "Please select a cryptocurrency";
        isFormValid = false;
      } else {
        newError.cryptoType = "";
      }
    }

    setError(newError);
    return isFormValid;
  };

  const handleBlur = () => {
    checkValidation("cryptoType");
  };
  useEffect(() => {
    if (dyanamicCryptoAddress) {
      setAddress(dyanamicCryptoAddress);
      setIsAddressAvailable(true);
    }
  }, [dyanamicCryptoAddress]);

  const handleCopyAddress = () => {
    if (address) {
      navigator.clipboard
        .writeText(address)
        .then(() => {
          toast.success("Address copied!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        })
        .catch((err) => {
          toast.error("Failed to copy address", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        });
    }
  };

  return (
    <Grid item xs={6} md={6} sx={{ display: "flex", justifyContent: "center" }}>
      {" "}
      <Card
        style={cardStyle}
        sx={{
          p: { md: theme.spacing(0.3), xs: theme.spacing(0.1) },
          height: "100% !important",
          boxSizing: "border-box",
        }}
      >
        <CardContent
          sx={{ p: { md: theme.spacing(0.2), xs: theme.spacing(0.1) } }}
        >
          <Stack spacing={{ xs: "10px", md: "15px" }}>
            <Item sx={{ display: "contents" }}>
              {" "}
              <Typography variant="h5">Choose currency and network</Typography>
              <Typography
                variant="h6"
                sx={{
                  color: "#7E7E7E",
                  textTransform: "uppercase",
                  fontSize: {
                    xs: "10px !important",
                    md: "12px !important",
                    lg: "14px !important",
                  },
                }}
              >
                Note: All currencies are converted to usdc on the time of
                deposit.
              </Typography>
            </Item>
            <Divider sx={{ border: "1px solid rgba(255, 255, 255, 0.2)" }} />
            <Typography variant="h6" sx={{ display: "block", mt: 2 }}>
              Select Crypto-Currency
            </Typography>
            <FormControl sx={{ m: 1, minWidth: 120, width: "100%" }}>
              <Select
                sx={{
                  "& .MuiSelect-select": {
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    padding: "12px 16px",
                    [theme.breakpoints.down("md")]: {
                      padding: "10px 16px",
                    },
                  },
                }}
                labelId="demo-controlled-open-select-label"
                id="demo-controlled-open-select"
                onChange={(e) => {
                  handleChange(e);
                }}
                onBlur={handleBlur}
                defaultValue="select"
                name="cryptoType"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      bgcolor: "black",
                      "& .MuiMenuItem-root": {
                        padding: 1,
                        fontFamily: "Ubuntu",
                        fontStyle: "normal",
                        fontWeight: 400,
                        fontSize: "14px",
                      },
                    },
                  },
                }}
              >
                <MenuItem disabled value="select">
                  <em>Select</em>
                </MenuItem>

                {loadingCurrency ? (
                  <MenuItem disabled>
                    <CircularProgress size={24} />
                    <Typography ml={2}>Loading...</Typography>
                  </MenuItem>
                ) : Array.isArray(coinList) && coinList.length > 0 ? (
                  coinList.map((item) => (
                    <MenuItem
                      key={item.Id}
                      value={item.Symbol}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          width: "100%",
                        }}
                      >
                        <Box
                          component="img"
                          src={getCryptoIcon(item.Symbol)}
                          alt={item.Name}
                          onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                            e.currentTarget.src = 'https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons@master/128/color/generic.png';
                          }}
                          sx={{
                            width: 24,
                            height: 24,
                            objectFit: 'contain'
                          }}
                        />
                        <Typography textAlign="left" sx={{ fontSize: "16px" }}>
                          {item.Name} ({item.Symbol})
                        </Typography>
                      </Box>
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>
                    <Typography>No currencies available</Typography>
                  </MenuItem>
                )}
              </Select>
              {error?.cryptoType && (
                <Typography sx={{ color: "red" }}>
                  {error.cryptoType}
                </Typography>
              )}
            </FormControl>
            <Typography variant="h6" sx={{ display: "block", mt: 2 }}>
              Copy your wallet address
            </Typography>
            <Item>
              <Box sx={{ width: "100%", display: "flex", gap: 1 }}>
                <TextField
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      [theme.breakpoints.down("md")]: {
                        padding: "10px 0px 10px 10px",
                      },
                    },
                  }}
                  value={dyanamicCryptoAddress}
                  InputProps={{
                    readOnly: true,
                    sx: { color: "#fff" },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onMouseDown={(e) => {
                            e.preventDefault();
                          }}
                          onClick={handleCopyAddress}
                          edge="end"
                          disabled={lodingQrLoding}
                        >
                          {lodingQrLoding ? (
                            <CircularProgress size={24} sx={{ color: "#fff" }} />
                          ) : (
                            <ContentCopyIcon sx={{ color: "#fff" }} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Item>
            <Grid item xs={12}>
              <Typography
                component="h5"
                sx={{
                  color: "white",
                  textAlign: "center",
                  fontSize: { xs: "14px", md: "16px", lg: "18px" },
                  mb: 2
                }}
              >
                Scan the QR code or copy the receiving address
              </Typography>
              {dyanamicCryptoAddress ? (
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'center',
                  backgroundColor: '#fff',
                  padding: '20px',
                  borderRadius: '8px',
                  width: 'fit-content',
                  margin: '0 auto'
                }}>
                  <QRCodeSVG
                    value={dyanamicCryptoAddress}
                    size={200}
                    level="H"
                  />
                </Box>
              ) : lodingQrLoding ? (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <CircularProgress size={48} sx={{ color: "#fff" }} />
                </Box>
              ) : null}
            </Grid>

            <Box sx={{ p: { xs: "0px", md: "0px", lg: "50px" } }}>
              <Card
                sx={{
                  margin: "0 auto",
                  background: "none",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  maxWidth: "920px",
                  overflow: "auto",
                }}
              >
                <div className={classes.kycContent}>
                  {paymentStatus.payment && (
                    <Box sx={{ 
                      mb: 3, 
                      p: 3,
                      bgcolor: 'rgba(60, 55, 255, 0.05)', 
                      borderRadius: 3,
                      border: '1px solid rgba(60, 55, 255, 0.1)',
                      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
                    }}>
                      <Stack spacing={2.5}>
                        {/* Header */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Box sx={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            animation: paymentStatus.payment.status === 4 ? 'pulse 1.5s infinite' : 'none',
                            bgcolor: paymentStatus.payment.status === 2 ? '#4CAF50' :
                                    paymentStatus.payment.status === 3 || paymentStatus.payment.status === 6 ? '#f44336' :
                                    paymentStatus.payment.status === 7 ? '#ff9800' : '#2196f3',
                            '@keyframes pulse': {
                              '0%': { opacity: 1 },
                              '50%': { opacity: 0.4 },
                              '100%': { opacity: 1 },
                            }
                          }} />
                          <Typography variant="h6" sx={{ 
                            color: '#3C37FF',
                            fontWeight: 600,
                            letterSpacing: '0.5px'
                          }}>
                            Payment Status
                          </Typography>
                        </Box>

                        {/* Status Box */}
                        <Box sx={{ 
                          p: 2,
                          bgcolor: paymentStatus.payment.status === 2 ? 'rgba(46, 125, 50, 0.1)' :
                                  paymentStatus.payment.status === 3 || paymentStatus.payment.status === 6 ? 'rgba(211, 47, 47, 0.1)' :
                                  paymentStatus.payment.status === 7 ? 'rgba(237, 108, 2, 0.1)' : 'rgba(25, 118, 210, 0.1)',
                          borderRadius: 2,
                          border: '1px solid',
                          borderColor: paymentStatus.payment.status === 2 ? 'rgba(46, 125, 50, 0.2)' :
                                     paymentStatus.payment.status === 3 || paymentStatus.payment.status === 6 ? 'rgba(211, 47, 47, 0.2)' :
                                     paymentStatus.payment.status === 7 ? 'rgba(237, 108, 2, 0.2)' : 'rgba(25, 118, 210, 0.2)',
                        }}>
                          <Typography sx={{ 
                            color: '#fff',
                            fontWeight: 500,
                            fontSize: '1.1rem',
                            textAlign: 'center'
                          }}>
                            {getPaymentStatusInfo(paymentStatus.payment.status).message}
                          </Typography>
                        </Box>

                        {/* Payment Details */}
                        <Stack spacing={2} sx={{ 
                          p: 2,
                          bgcolor: 'rgba(255, 255, 255, 0.03)',
                          borderRadius: 2
                        }}>
                          {paymentStatus.payment.amount > 0 && (
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                              <Typography sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                                Amount
                              </Typography>
                              <Typography sx={{ 
                                color: '#fff',
                                fontWeight: 600,
                                fontSize: '1.1rem'
                              }}>
                                {paymentStatus.payment.amount} {paymentStatus.payment.currency}
                              </Typography>
                            </Box>
                          )}
                          
                          {paymentStatus.payment.transactionId && (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                              <Typography sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                                Transaction ID
                              </Typography>
                              <Typography sx={{ 
                                color: '#fff',
                                bgcolor: 'rgba(255, 255, 255, 0.05)',
                                p: 1.5,
                                borderRadius: 1,
                                fontFamily: 'monospace',
                                fontSize: '0.9rem',
                                wordBreak: 'break-all'
                              }}>
                                {paymentStatus.payment.transactionId}
                              </Typography>
                            </Box>
                          )}
                        </Stack>
                      </Stack>
                    </Box>
                  )}
                  <Box sx={{
                    p: 3,
                    bgcolor: 'rgba(60, 55, 255, 0.08)',
                    borderRadius: 2,
                    border: '1px solid rgba(60, 55, 255, 0.15)',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
                  }}>
                    <Stack spacing={2.5}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box component="span" sx={{
                          color: '#3C37FF',
                          fontSize: '24px',
                          lineHeight: 1
                        }}>
                          ⓘ
                        </Box>
                        <Typography component="h5" sx={{
                          fontWeight: "600",
                          color: '#3C37FF',
                          fontSize: { xs: '16px', md: '18px' }
                        }}>
                          Important Notice
                        </Typography>
                      </Box>
                      
                      <Stack spacing={2} sx={{
                        pl: 2,
                        borderLeft: '2px solid rgba(60, 55, 255, 0.2)'
                      }}>
                       
                        <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          bgcolor: 'rgba(255, 255, 255, 0.05)',
                          p: 2,
                          borderRadius: 1.5
                        }}>
                          <Box component="span" sx={{ fontSize: '20px' }}>⏱️</Box>
                          <Typography
                            component="p"
                            sx={{
                              fontSize: { xs: "12px", md: "14px", lg: "15px" },
                              color: 'rgba(255, 255, 255, 0.9)',
                              lineHeight: 1.5
                            }}
                          >
                            Payment processing can take up to <strong>5-10 minutes</strong> . We will inform you once the transaction is completed.
                          </Typography>
                        </Box>

                         <Typography
                          component="p"
                          sx={{
                            fontSize: { xs: "12px", md: "14px", lg: "15px" },
                            color: 'rgba(255, 255, 255, 0.9)',
                            lineHeight: 1.6
                          }}
                        >
                          Please ensure your transfer includes both the deposit amount <em>and</em> the transfer fee. The displayed amount does not include network fees.
                        </Typography>
                        
                      </Stack>
                    </Stack>
                  </Box>
                </div>
              </Card>

            </Box>
          
          </Stack>
        </CardContent>
      </Card>
    </Grid>
  );
};
